import { CurrentUserContextType, MenuItem } from "./interfaces";

export const personSorts = [
    {
        id: 0,
        name: 'Zamestnanec'
    }, {
        id: 1,
        name: 'Dohodár',
    }, {
        id: 2,
        name: 'Freelancer'
    }, {
        id: 3,
        name: 'Subdodávateľ'
    }
]


export const personTypes = [
    {
        id: 0,
        name: 'Fakturovaná'
    }, {
        id: 1,
        name: 'Réžijná',
    }
];

export const personStatuses = [
    {
        id: 0,
        name: 'Neaktívny'
    }, {
        id: 1,
        name: 'Aktívny',
    }
];

export const yesNo = [
    {
        id: 0,
        name: 'Nie'
    }, {
        id: 1,
        name: 'Áno',
    }
];


export const openClosed = [
    {
        id: 0,
        name: 'Zatvorený'
    }, {
        id: 1,
        name: 'Otvorený',
    }
];


export const projectFlags = [
    {
        id: 0,
        name: 'Normálny'
    }, {
        id: 1,
        name: 'Globálny (pre všetkých)',
    }
];


export const adminLevels = [
    {
        id: 0,
        name: 'Užívateľ'
    }, {
        id: 1,
        name: 'Schvalovateľ',
    }, {
        id: 2,
        name: 'Schvalovateľ+'
    }, {
        id: 9,
        name: 'Administrátor',
    }
];

export const menuItems: MenuItem[] = [
    {
        icon: "list-check",
        link: "/dashboard/month",
        text: "Mesačný výkaz",
        visible: (currentUser: CurrentUserContextType) => currentUser.adminLevel >= 0
    }, {
        link: "/dashboard/reporting",
        icon: "list-check",
        text: "Mesačné výkazy",
        visible: (currentUser: CurrentUserContextType) => (currentUser.adminLevel >= 1 ||  currentUser.projectManager)
    }, {
        link: "/dashboard/project",
        icon: "diagram-project",
        text: "Projekty",
        visible: (currentUser: CurrentUserContextType) => currentUser.adminLevel >= 2
        // }, {
        //     link: "/dashboard/order",
        //     icon: "money-check",
        //     text: "Zákazky",
        //     level: 9
    }, {
        link: "/dashboard/activity",
        icon: "chart-line",
        text: "Aktivity",
        visible: (currentUser: CurrentUserContextType) => currentUser.adminLevel >= 9
    }, {
        link: "/dashboard/person",
        icon: "person",
        text: "Osoby",
        visible: (currentUser: CurrentUserContextType) => currentUser.adminLevel >= 2
    }, {
        link: "/dashboard/product",
        icon: "umbrella",
        text: "Produkty",
        visible: (currentUser: CurrentUserContextType) => currentUser.adminLevel >= 9
    }, {
        link: "/dashboard/position",
        icon: "code-compare",
        text: "Pozície",
        visible: (currentUser: CurrentUserContextType) => currentUser.adminLevel >= 9
    }, {
        link: "/dashboard/company",
        icon: "building",
        text: "Spoločnosti",
        visible: (currentUser: CurrentUserContextType) => currentUser.adminLevel >= 9
    }, {
        link: "/dashboard/center",
        icon: "arrows-to-circle",
        text: "Strediská",
        visible: (currentUser: CurrentUserContextType) => currentUser.adminLevel >= 9
    }, {
        link: "/dashboard/setting",
        icon: "gear",
        text: "Nastavenia",
        visible: (currentUser: CurrentUserContextType) => currentUser.adminLevel >= 9
    }
]


export const weekDays = [
    {
        name: 'Nedeľa',
        name2: 'Ne'
    }, {
        name: 'Pondelok',
        name2: 'Po'
    }, {
        name: 'Utorok',
        name2: 'Ut'
    }, {
        name: 'Streda',
        name2: 'St'
    }, {
        name: 'Štvrtok',
        name2: 'Št'
    }, {
        name: 'Piatok',
        name2: 'Pi'
    }, {
        name: 'Sobota',
        name2: 'So'
    },

]